export enum Variant {
    Minimal = 'minimal',
    Full = 'full',
}
